import * as React from 'react'
import { SettingsCategory } from '../util/SettingsConfigurations';
import './SettingsSidebarItem.css'

export type ValueProps = {
  category: SettingsCategory
  selectedCategory: SettingsCategory
}

export type EventProps = {
  onClick: (category: SettingsCategory) => void
}

export type Props = ValueProps & EventProps

export const SettingsSidebarItem = (props: Props) => {
  const {category, selectedCategory} = props
  const onClick = () => props.onClick(category)
  const selected = selectedCategory === category
  const baseClassName = 'settings-sidebar-item'
  const selectedClassName = selected ? `${baseClassName} settings-sidebar-item-selected` : baseClassName

  return (
    <div data-test-id={`${props.category}-settings-sidebar-item`} className={selectedClassName} onClick={onClick}>
      <span>{props.category}</span>
    </div>
  )
}